import { TrainingOfferModality } from "@root/utils/enums/offer";

export const isTrainingOfferAddressRequired = (remote: TrainingOfferModality.FULL_REMOTE | null | undefined) => {
  return remote !== TrainingOfferModality.FULL_REMOTE;
};
